import { parse, stringify } from 'query-string';
import { history } from './history';

export const round = (num: number) => Math.round(num * 10) / 10;

export const getFilename = (header: string | null) => {
  if (header === null) return undefined;
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(header);
  if (matches != null && matches[1]) {
    return matches[1].replace(/['"]/g, '');
  }
  return undefined;
};

export const literalNumbers = [
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten'
];

export const { key } = parse(window.location.search);

export const getCode = () => parse(window.location.search).code;

export const setCode = (code: string) => {
  history.push({ ...window.location, search: stringify({ key, code }) });
};
